"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.policys = exports.remotePython = exports.localPython = exports.playgroundPython = exports.remoteNode = exports.localNode = exports.playgroundNode = void 0;
exports.playgroundNode = {
    "package.json": { allowExistingFile: true, policy: "add" },
    ".vscode/launch.json": { allowExistingFile: true, policy: "add" },
    ".vscode/tasks.json": { allowExistingFile: true, policy: "add" },
    "env/.env.playground": { allowExistingFile: false, policy: "skip" },
    "env/.env.playground.user": { allowExistingFile: false, policy: "skip" },
    "m365agents.playground.yml": { allowExistingFile: false, policy: "error" },
};
exports.localNode = {
    "package.json": { allowExistingFile: true, policy: "add" },
    ".vscode/launch.json.tpl": { allowExistingFile: true, policy: "add" },
    ".vscode/tasks.json.tpl": { allowExistingFile: true, policy: "add" },
    "env/.env.local": { allowExistingFile: false, policy: "skip" },
    "m365agents.local.yml.tpl": { allowExistingFile: false, policy: "error" },
};
exports.remoteNode = {
    ".vscode/launch.json.tpl": { allowExistingFile: true, policy: "add" },
    ".vscode/tasks.json": { allowExistingFile: true, policy: "add" },
    "env/.env.dev": { allowExistingFile: false, policy: "skip" },
    "infra/azure.bicep.tpl": { allowExistingFile: false, policy: "skip" },
    "infra/azure.parameters.json.tpl": { allowExistingFile: false, policy: "skip" },
    "infra/botRegistration/azureBot.bicep": { allowExistingFile: false, policy: "skip" },
    "infra/botRegistration/readme.md": { allowExistingFile: false, policy: "skip" },
    "m365agents.yml.tpl": { allowExistingFile: false, policy: "error" },
    "web.config": { allowExistingFile: true, policy: "skip" },
    ".webappignore": { allowExistingFile: true, policy: "skip" },
};
exports.playgroundPython = {
    ".vscode/launch.json": { allowExistingFile: true, policy: "add" },
    ".vscode/tasks.json": { allowExistingFile: true, policy: "add" },
    "env/.env.playground": { allowExistingFile: false, policy: "skip" },
    "env/.env.playground.user": { allowExistingFile: false, policy: "skip" },
    "m365agents.playground.yml": { allowExistingFile: false, policy: "error" },
};
exports.localPython = {
    ".vscode/launch.json.tpl": { allowExistingFile: true, policy: "add" },
    ".vscode/tasks.json.tpl": { allowExistingFile: true, policy: "add" },
    "env/.env.local": { allowExistingFile: false, policy: "skip" },
    "m365agents.local.yml.tpl": { allowExistingFile: false, policy: "error" },
};
exports.remotePython = {
    ".vscode/launch.json.tpl": { allowExistingFile: true, policy: "add" },
    "env/.env.dev": { allowExistingFile: false, policy: "skip" },
    "infra/azure.bicep.tpl": { allowExistingFile: false, policy: "skip" },
    "infra/azure.parameters.json.tpl": { allowExistingFile: false, policy: "skip" },
    "infra/botRegistration/azureBot.bicep": { allowExistingFile: false, policy: "skip" },
    "infra/botRegistration/readme.md": { allowExistingFile: false, policy: "skip" },
    "m365agents.yml.tpl": { allowExistingFile: false, policy: "error" },
    ".webappignore": { allowExistingFile: true, policy: "skip" },
};
exports.policys = {
    "playground-typescript": exports.playgroundNode,
    "local-typescript": exports.localNode,
    "remote-typescript": exports.remoteNode,
    "playground-python": exports.playgroundPython,
    "local-python": exports.localPython,
    "remote-python": exports.remotePython,
};
//# sourceMappingURL=copyPolicy.js.map